export function splitReservationLotNo(value) {
  const rawLotNo = String(value || "").trim();
  const match = rawLotNo.match(/^(.+)\/(R\d+)$/i);
  return {
    rawLotNo,
    lotNo: match ? match[1] : rawLotNo,
    reservationNo: match ? match[2].toUpperCase() : null,
  };
}

export function formatReservationLotNo(value) {
  const { lotNo, reservationNo } = splitReservationLotNo(value);
  return reservationNo ? `${lotNo} | Rez No: ${reservationNo}` : lotNo;
}
